import { configureStore } from "shared/store";
import { isRenterLikeApp } from "shared/utils/auth";

const createStore = () => (isRenterLikeApp() ? configureStore() : null);

export default createStore;
